var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"footer",attrs:{"app":"","fixed":"","height":24}},[_c('app-status-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }